import { IAction } from 'types/action';
import { initialState, IState } from '../../modules/pyc-redeem/pyc-redeem.reducer';

import { ITEM_SELECTION_PAGE, ITEMS_DISPLAY_PAGE, REDEEM_SUCCESS } from '../../states/states.constants';
import { SWITCH_PREVIEW_STATE_HOST } from '@sitegen/common/types/root-actions';
import { IContentPackItem, ITEM_TYPE } from '@sitegen/common/types';
import { IAgeRatings } from '@sitegen/common/constants/age-ratings';
import { EDITION } from '@sitegen/common/constants/editions';

const contentGameItemsMock: IContentPackItem[] = [
    {
        actionIds: ['1651'],
        packId: 'boring_adventure_pc_standard',
        type: ITEM_TYPE.KEY_DELIVERY,
        ratings: {
            PEGI: 'PEGI_7',
            USK: 'USK_18',
            ESRB: 'ESRB_E10plus',
            DJCTQ: 'DJCTQ_12',
            ACB: 'ACB_MA15plus',
            RARS: '',
            CERO: '',
            GRAC: '',
            GSRR: '',
            OFLC: 'OFLC_R13'
        } as unknown as IAgeRatings,
        name: 'selectedItem',
        edition: EDITION.STANDART,
        hidden: false,
        ownershipGroups: [
            ['2'],
            ['1', '3', '5']
        ],
        alreadyOwned: false,
        description: 'Game synopsis morem ipsum dolor sit amet, consectetur',
        imageSrc: 'https://images-na.ssl-images-amazon.com/images/I/9186v02Ic5S._SX522_.jpg',
    },
    {
        actionIds: ['1652'],
        packId: 'bloody_shooter_pc_gold',
        type: ITEM_TYPE.KEY_DELIVERY,
        ratings: {
            PEGI: 'PEGI_7',
            USK: 'USK_18',
            ESRB: 'ESRB_E10plus',
            DJCTQ: 'DJCTQ_12',
            ACB: 'ACB_MA15plus',
            RARS: '',
            CERO: '',
            GRAC: '',
            GSRR: '',
            OFLC: 'OFLC_R13'
        } as unknown as IAgeRatings,
        name: 'Prince of Persia: The Sands of Time',
        edition: EDITION.GOLD,
        hidden: false,
        ownershipGroups: [
            ['7', '6']
        ],
        alreadyOwned: true,
        description: 'Game synopsis morem ipsum dolor sit amet, consectetur',
        imageSrc: 'https://images-na.ssl-images-amazon.com/images/I/9186v02Ic5S._SX522_.jpg',
    },
];

const selectedGameItemIdMock: string = contentGameItemsMock[0].actionIds![0];

export const PYCRedeemReducer = (state = initialState, action: IAction): IState => {
    switch (action.type) {
    case SWITCH_PREVIEW_STATE_HOST: {
        switch (action.payload) {
        case ITEMS_DISPLAY_PAGE:
            return {
                ...initialState,
                contentGameItems: contentGameItemsMock
            };
        case ITEM_SELECTION_PAGE:
            return {
                ...initialState,
                contentGameItems: contentGameItemsMock,
                selectedGameItemId: selectedGameItemIdMock
            };
        case REDEEM_SUCCESS:
            return {
                ...initialState,
                contentGameItems: contentGameItemsMock,
                selectedGameItemId: selectedGameItemIdMock
            };
        default:
            return state;
        }
    }
    default:
        return state;
    }
};

export default PYCRedeemReducer;
